/* eslint-disable no-restricted-imports */
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useIsStreaksPreRewardsEnabled() {
  return useCbhFlag(CbhFeatureFlag.STREAKS_PRE_REWARD, {
    defaultValue: false,
  });
}
